import React from 'react';
import {connect} from 'react-redux';
import {cloakingDomainAction} from '../../../store/actions/cloakingDomainAction';
import DomainList from './DomainList';

export const CloakingDomainsList = props => <DomainList {...props} kind="cloaking"/>;

export default connect(null, {remove: cloakingDomainAction.remove})(CloakingDomainsList);
